import { render } from "./HorizontalLabel.vue?vue&type=template&id=928aaea0&scoped=true"
import script from "./HorizontalLabel.vue?vue&type=script&lang=js"
export * from "./HorizontalLabel.vue?vue&type=script&lang=js"

import "./HorizontalLabel.vue?vue&type=style&index=0&id=928aaea0&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-928aaea0"

export default script